export enum PaymentMode {
    ADD = 'add',
    EDIT = 'edit'
}
